import React, { useEffect } from 'react'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { VariableWarehouse } from '../warehouses-crud/VariableWarehouse';


function FilterProduct({ translate, noPadding, bigTitle }) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableWarehouse();
    const Filter = (e) => {
        e.preventDefault()
        //dispatch(filterEvaluationType(state.name, state.creative_work_type_id, setLoad))
    }
    return (
        <div className='filteruser ' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={noPadding && { padding: "24px 0px 10px 0px" }} >
            {
                bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                    <h3>{translate('search_filter')}</h3>
            }

            <div className='div_filter' >
                <input className={`input_filter ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('name')} onChange={(e) => setStateCustom('name', e.target.value)} />
                <select className={`select_filter  ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} onChange={(e) => setStateCustom('status', e.target.value)} >
                    <option disabled selected >{translate('category')}</option>
                    <option value={true} >cat1</option>
                    <option value={false} >cat2</option>
                </select>
                <input className={`input_filter ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('type')} onChange={(e) => setStateCustom('name', e.target.value)} />
                <button className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterProduct